import React from 'react';
import '../../assets/css/popmodel/PermissionModal1.css';

function PermissionModal({ show, onClose, permissions = [], userName }) {
  if (!show) return null;

  // Group permissions by module, e.g. "create_User" => { User: ["create"] }
  const groupPermissions = (flatPermissions) => {
    return flatPermissions.reduce((acc, perm) => {
      if (!perm || typeof perm !== 'string') return acc;

      if (!perm.includes('_')) return acc; // skip if format not correct

      const [action, module] = perm.split('_');

      if (!action || !module) return acc;

      if (!acc[module]) acc[module] = [];
      if (!acc[module].includes(action)) acc[module].push(action);

      return acc;
    }, {});
  };

  const capitalize = (word) => word.charAt(0).toUpperCase() + word.slice(1);

  const grouped = groupPermissions(permissions);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h5>Permissions{userName ? ` for ${userName}` : ''}</h5>
          <button onClick={onClose} className="modal-close-btn" aria-label="Close modal">×</button>
        </div>
        <div className="modal-body">
          {Object.keys(grouped).length > 0 ? (
            <div className="table-wrapper">
              <table className="permissions-table">
                <thead>
                  <tr>
                    <th>Module</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(grouped).map(([module, actions]) => (
                    <tr key={module}>
                      <td className="module-cell" style={{ border:'1px solid #102234'}}>{capitalize(module)}</td>
                      <td style={{ border:'1px solid #102234'}}>
                        {actions.map((action, i) => (
                          <span key={i} className="badge">{capitalize(action)}</span>
                        ))}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="no-permissions">No permissions assigned.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default PermissionModal;
